export enum DateTimeUnit {
  DAY = 'day',
  YEAR = 'year',
  MONTH = 'month',
}
